"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var styles = require('./MessageAdListItem.scss');
var classNames = require('classnames/bind').bind(styles);
var TwistyContainer = /** @class */ (function (_super) {
    tslib_1.__extends(TwistyContainer, _super);
    function TwistyContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TwistyContainer.prototype.render = function () {
        var twistyClasses = classNames(this.props.isReadingPanePositionOff
            ? styles.twistySingleLine
            : styles.twistyThreeColumn, 'visibilityHidden');
        return (React.createElement("div", { className: 'fbAdLink' },
            React.createElement("div", { className: twistyClasses })));
    };
    TwistyContainer = tslib_1.__decorate([
        mobx_react_1.observer
    ], TwistyContainer);
    return TwistyContainer;
}(React.Component));
exports.default = TwistyContainer;
//# sourceMappingURL=TwistyContainer.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-list-view/lib/components/TwistyContainer.js
// module id = 5998
// module chunks = 67